export default __webpack_public_path__ + "static/media/officeSafetyLogo.5a1f0e41.png";